// extracted by mini-css-extract-plugin
export default {"card":"P4-z"};